import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeFeatureSkeleton } from "./TypeFeature";

export interface TypeMembershipCompareFields {
    name: EntryFieldTypes.Symbol;
    title: EntryFieldTypes.Symbol;
    introduction?: EntryFieldTypes.RichText;
    badge?: EntryFieldTypes.Symbol;
    color: EntryFieldTypes.Symbol<"gold">;
    logo1?: EntryFieldTypes.AssetLink;
    description1?: EntryFieldTypes.RichText;
    features1: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeFeatureSkeleton>>;
    logo2?: EntryFieldTypes.AssetLink;
    description2?: EntryFieldTypes.RichText;
    features2?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeFeatureSkeleton>>;
    ctaLabel?: EntryFieldTypes.Symbol;
    ctaUrl?: EntryFieldTypes.Symbol;
}

export type TypeMembershipCompareSkeleton = EntrySkeletonType<TypeMembershipCompareFields, "membershipCompare">;
export type TypeMembershipCompare<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeMembershipCompareSkeleton, Modifiers, Locales>;

export function isTypeMembershipCompare<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeMembershipCompare<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'membershipCompare'
}
